"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Implementation of the PreparedMessage interface used to post messages between
 * two frames using window.postMessage
 */
class CrossFramePreparedMessage {
    /**
     * Creates an instance of CrossFramePreparedMessage.
     * @param _message The message to be sent
     * @param _target The target window where the message will be sent
     * @param _origin The targetOrigin where this message can be received
     */
    constructor(_message, _target, _origin) {
        this._message = _message;
        this._target = _target;
        this._origin = _origin;
    }
    get messageGuid() {
        return this._message.msgGuid;
    }
    send() {
        this._target.postMessage(this._message, this._origin);
        return this;
    }
}
exports.CrossFramePreparedMessage = CrossFramePreparedMessage;
//# sourceMappingURL=CrossFramePreparedMessage.js.map